import { forwardRef } from "react"

import { Box, Stack, type BoxProps, type StackProps } from "@mui/material"

import type { FC } from ".."

/** General container component */
export const Container = forwardRef<HTMLElement, BoxProps>(({ sx, ...props }, ref) => (
  <Box
    ref={ref}
    component="section"
    maxWidth={1556}
    sx={[
      {
        margin: "0 auto",
        px: { xs: 4, sm: 5 },
        width: "100%",
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...props}
  />
))
Container.displayName = "Container"

/** General container grid component */
export const Grid: FC<BoxProps> = (props) => (
  <Box
    display="grid"
    gridTemplateColumns={{
      xs: "repeat(6, minmax(0, 1fr))",
      sm: "repeat(4, minmax(0, 1fr))",
      md: "repeat(8, minmax(0, 1fr))",
      lg: "repeat(12, minmax(0, 1fr))",
    }}
    columnGap={{ xs: 3.5, sm: 5 }}
    rowGap={{ xs: 3.5, sm: 5 }}
    {...props}
  />
)

/** General container stack component */
export const ContainerGrid: FC<BoxProps> = (props) => (
  <Container>
    <Grid {...props} />
  </Container>
)

// export interface StackProps extends StackProps {}
/** General container stack component */
export const ContainerStack: FC<StackProps> = (props) => (
  <Container>
    <Stack {...props} />
  </Container>
)
